function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useState } from 'react';
import { getCssVariableValue } from "../../utils";
import useIsomorphicLayoutEffect from "../../utils/useIsomorphicLayoutEffect";
export var hexToRGBA = function hexToRGBA(color) {
  var hex = color.replace(/^#?([a-f\d])([a-f\d])$/i, function (_, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), 255] : [0, 0, 0, 0];
};
var calculateLuminance = function calculateLuminance(r, g, b, a) {
  var rsRGB = r / 255;
  var gsRGB = g / 255;
  var bsRGB = b / 255;
  var rLinear = rsRGB <= 0.03928 ? rsRGB / 12.92 : Math.pow((rsRGB + 0.055) / 1.055, 2.4);
  var gLinear = gsRGB <= 0.03928 ? gsRGB / 12.92 : Math.pow((gsRGB + 0.055) / 1.055, 2.4);
  var bLinear = bsRGB <= 0.03928 ? bsRGB / 12.92 : Math.pow((bsRGB + 0.055) / 1.055, 2.4);
  return 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
};
var isFullyTransparent = function isFullyTransparent(color) {
  if (!color) return true;
  if (color === 'transparent') {
    return true;
  }
  if (color.startsWith('rgba')) {
    var alpha = parseFloat(color.slice(color.lastIndexOf(',') + 1, -1).trim());
    return alpha === 0;
  }
  return false;
};
var cache = {};
var numberOfCalculations = 0;
var numberOfCalculationRequests = 0;
export var getContrastRatio = function getContrastRatio() {
  var color1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#ffffff';
  var color2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#ffffff';
  function calculate() {
    // console.time('test');
    var _ref = color1.startsWith('#') ? hexToRGBA(color1) : color1.slice(5, -1).split(',').map(Number),
      _ref2 = _slicedToArray(_ref, 4),
      r1 = _ref2[0],
      g1 = _ref2[1],
      b1 = _ref2[2],
      a1 = _ref2[3];
    var _ref3 = color2.startsWith('#') ? hexToRGBA(color2) : color2.slice(5, -1).split(',').map(Number),
      _ref4 = _slicedToArray(_ref3, 4),
      r2 = _ref4[0],
      g2 = _ref4[1],
      b2 = _ref4[2],
      a2 = _ref4[3];
    var l1 = calculateLuminance(r1, g1, b1, a1);
    var l2 = calculateLuminance(r2, g2, b2, a2);
    numberOfCalculations += 1;
    var value = (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
    cache["".concat(color1, "_").concat(color2)] = value;
    // console.timeEnd('test');
    return value;
  }
  numberOfCalculationRequests += 1;
  var value = cache["".concat(color1, "_").concat(color2)] || cache["".concat(color2, "_").concat(color1)] || calculate();
  return value;
};
export var BackgroundContext = /*#__PURE__*/React.createContext({});
var BackgroundProvider = function BackgroundProvider(_ref5) {
  var children = _ref5.children,
    value = _ref5.value;
  if (!value.cssValue) return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    hexValue = _useState2[0],
    setHexValue = _useState2[1];
  var contextValue = _objectSpread({}, value);
  contextValue.hexValue = hexValue || getCssVariableValue(value.cssValue);
  var handleColorChange = function handleColorChange() {
    setHexValue(getCssVariableValue(value.cssValue));
  };
  useIsomorphicLayoutEffect(function () {
    if (typeof window !== 'undefined' && window.matchMedia) {
      var mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      // Using addListener for backwards compatibility with IE11
      var addEvent = mediaQuery.addEventListener || mediaQuery.addListener;
      var removeEvent = mediaQuery.removeEventListener || mediaQuery.removeListener;
      addEvent.call(mediaQuery, 'change', handleColorChange);
      return function () {
        return removeEvent.call(mediaQuery, 'change', handleColorChange);
      };
    }
  }, []);
  useIsomorphicLayoutEffect(function () {
    handleColorChange();
  }, [value]);
  if (isFullyTransparent(contextValue.hexValue)) return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  return /*#__PURE__*/React.createElement(BackgroundContext.Provider, {
    value: contextValue
  }, children);
};
export function useBackgroundColor() {
  return useContext(BackgroundContext);
}
export function useInverse() {
  var _theme$config_backgro, _theme$config_backgro2;
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useContext = useContext(BackgroundContext),
    cssValue = _useContext.cssValue,
    hexValue = _useContext.hexValue;
  if (!cssValue && !hexValue) {
    return false;
  }
  var bgColor = hexValue || getCssVariableValue(cssValue);
  if ((_theme$config_backgro = theme.config_backgrounds_invert_true) !== null && _theme$config_backgro !== void 0 && _theme$config_backgro.includes(bgColor)) {
    return true;
  }
  if ((_theme$config_backgro2 = theme.config_backgrounds_invert_false) !== null && _theme$config_backgro2 !== void 0 && _theme$config_backgro2.includes(bgColor)) {
    return false;
  }
  if (bgColor) {
    return getContrastRatio(bgColor, getCssVariableValue(theme.vars.color_text_default_1) || '#000000') < 4.5;
  }
  return false;
}
export default BackgroundProvider;